var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1024,
    height: 1024,
    viewBox: "0 0 1024 1024",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M523.109 1021.86C798.423 1021.86 1021.61 798.673 1021.61 523.359C1021.61 248.045 798.423 24.859 523.109 24.859C247.795 24.859 24.609 248.045 24.609 523.359C24.609 798.673 247.795 1021.86 523.109 1021.86Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M503.109 14.142C773.027 14.142 991.838 232.842 991.838 502.618C991.838 772.394 773.027 991.095 503.109 991.095C233.191 991.095 14.379 772.396 14.379 502.618C14.379 232.84 233.191 14.142 503.109 14.142Z",
    fill: "url(#paint0_linear_68_29)",
    stroke: "#733306",
    strokeWidth: 24,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M525.397 48.659C261.997 48.44 48.645 261.79 48.864 525.19C48.8306 646.344 94.9951 762.951 177.95 851.25C84.977 764.15 26.804 640.35 26.689 503.01C26.47 239.61 239.82 26.259 503.221 26.479C640.558 26.593 764.362 84.767 851.462 177.74C763.161 94.7857 646.552 48.6229 525.397 48.659Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M517.578 893.765C725.099 893.765 893.328 725.536 893.328 518.015C893.328 310.494 725.099 142.265 517.578 142.265C310.057 142.265 141.828 310.494 141.828 518.015C141.828 725.536 310.057 893.765 517.578 893.765Z",
    fill: "#FFFB79"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M502.469 865.967C703.595 865.967 866.64 702.922 866.64 501.796C866.64 300.67 703.595 137.625 502.469 137.625C301.343 137.625 138.298 300.67 138.298 501.796C138.298 702.922 301.343 865.967 502.469 865.967Z",
    fill: "url(#paint1_linear_68_29)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M520.756 161.768C323.922 161.768 164.356 321.28 164.356 518.049C164.356 661.483 249.151 785.11 371.356 841.596C235.026 788.959 138.309 656.685 138.309 501.8C138.309 300.693 301.348 137.664 502.467 137.664C642.012 137.664 763.22 216.152 824.36 331.385C761.615 229.617 649.118 161.768 520.756 161.768ZM371.356 841.596L824.356 331.385Z",
    fill: "url(#paint2_linear_68_29)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M831.241 486.183L544.619 806.406C540.095 810.919 533.966 813.453 527.576 813.453C521.186 813.453 515.057 810.919 510.533 806.406L223.909 486.183C221.671 483.951 219.896 481.299 218.685 478.379C217.474 475.46 216.85 472.33 216.85 469.169C216.85 466.008 217.474 462.878 218.685 459.959C219.896 457.039 221.671 454.387 223.909 452.155L344.217 299.421C351.678 289.432 362.901 281.987 374.803 285.17H680.352C693.21 281.73 704.92 290.851 711.88 302.184L831.241 452.159C833.478 454.391 835.253 457.043 836.464 459.962C837.675 462.881 838.299 466.011 838.299 469.171C838.299 472.331 837.675 475.461 836.464 478.38C835.253 481.299 833.478 483.951 831.241 486.183Z",
    fill: "url(#paint3_linear_68_29)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M803.74 456.184L520.157 773.396C515.684 777.866 509.618 780.377 503.294 780.377C496.97 780.377 490.905 777.866 486.432 773.396L202.849 456.184C200.635 453.971 198.878 451.344 197.679 448.452C196.481 445.56 195.864 442.46 195.864 439.33C195.864 436.2 196.481 433.1 197.679 430.208C198.878 427.316 200.635 424.689 202.849 422.476L321.879 271.176C329.261 261.281 340.365 253.906 352.141 257.06H654.451C667.172 253.653 678.758 262.688 685.644 273.914L803.744 422.471C805.959 424.684 807.716 427.312 808.914 430.204C810.113 433.097 810.73 436.197 810.729 439.328C810.729 442.459 810.112 445.56 808.912 448.452C807.713 451.344 805.955 453.972 803.74 456.184Z",
    fill: "#FDEC3A"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M803.74 456.184L520.157 773.396C515.684 777.866 509.618 780.377 503.294 780.377C496.971 780.377 490.905 777.866 486.432 773.396L503.169 480.814L503.732 257.059H654.451C667.172 253.652 678.758 262.687 685.644 273.913L803.744 422.47C805.959 424.683 807.716 427.311 808.915 430.204C810.114 433.096 810.73 436.197 810.73 439.328C810.73 442.459 810.112 445.559 808.913 448.452C807.713 451.344 805.956 453.971 803.74 456.184Z",
    fill: "#E99D00"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M677.321 479.673L572.557 715.32L520.157 773.396C515.684 777.866 509.618 780.377 503.294 780.377C496.971 780.377 490.905 777.866 486.432 773.396L433.787 715.32L331.3 479.673H677.321Z",
    fill: "#FECA1B"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M677.321 479.673H331.3C331.3 479.673 195.531 444.516 195.9 437.973C196.224 432.126 198.698 426.606 202.846 422.473L321.876 271.173C329.258 261.278 340.362 253.903 352.138 257.057H654.448C667.169 253.65 678.755 262.685 685.641 273.911L803.741 422.468C806.03 424.75 807.829 427.474 809.029 430.475C810.229 433.476 810.803 436.69 810.718 439.921C810.569 445.828 677.321 479.673 677.321 479.673Z",
    fill: "#FECA1B"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M503.309 479.673H331.3C331.3 479.673 195.531 444.516 195.9 437.973C196.224 432.126 198.698 426.606 202.846 422.473L321.876 271.173C329.258 261.278 340.362 253.903 352.138 257.057H503.72L503.309 479.673Z",
    fill: "#FFF9CC"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M677.321 479.673H331.3L503.763 256.217L677.321 479.673Z",
    fill: "#FDEC3A"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_68_29",
    x1: 503.109,
    y1: 991.109,
    x2: 503.109,
    y2: 14.14,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBB00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDED3B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_68_29",
    x1: 502.469,
    y1: 865.921,
    x2: 502.469,
    y2: 137.671,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DD8901"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.781,
    stopColor: "#F0AA01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6C828"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_68_29",
    x1: 481.328,
    y1: 841.609,
    x2: 481.328,
    y2: 137.671,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E99000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9D5306"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_68_29",
    x1: 527.578,
    y1: 813.453,
    x2: 527.578,
    y2: 284.421,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9C5306"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E99000"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoin);
export default __webpack_public_path__ + "static/media/coin.aa85afa501ac070a0075acdbf447f128.svg";
export { ForwardRef as ReactComponent };